import {
  DELETE_LINK,
  GENERATE_LINK,
  GET_LINKS,
  GET_LINK_BY_ID,
} from './../actionTypes'
const initialState = {
  isReady: false,
  link: {},
  links: [],
}
export const linksReducer = (state = initialState, action) => {
  switch (action.type) {
    case GENERATE_LINK:
      return {
        ...state,
        links: [...state.links, action.payload],
      }
    case GET_LINK_BY_ID:
      return {
        ...state,
        isReady: false,
        link: action.payload,
      }
    case GET_LINKS:
      return {
        ...state,
        isReady: true,
        links: action.payload,
      }
    case DELETE_LINK: {
      return {
        ...state,
        links: state.links.filter((link) => link._id !== action.payload),
      }
    }
    default:
      return state
  }
}
